module.exports = __webpack_public_path__ + "static/media/regiao_norte.47627769.svg";